<div class="main-section-wrapper">
    <div class="main-section">
        <ng-container [ngSwitch]="selectedComponent | async">
            <personal-data-validation *ngSwitchCase="'personal'"></personal-data-validation>
            <token-validation *ngSwitchCase="'token'"></token-validation>
            <eligibility-analysis *ngSwitchCase="'eligibility'"></eligibility-analysis>
            <waiting-verification
                *ngSwitchCase="'waitingVerification'"
                [hasRedirect]="true"
                [onCloseRedirectUrl]="''"
            ></waiting-verification>
            <eligibility-delay *ngSwitchCase="'eligibilityDelay'"></eligibility-delay>
            <no-agreement-proposal *ngSwitchCase="'noAgreement'"></no-agreement-proposal>
            <reject-agreement *ngSwitchCase="'rejectAgreement'" [onRedirectUrl]="''"></reject-agreement>
            <acceptance-agreement *ngSwitchCase="'acceptanceAgreement'"></acceptance-agreement>
            <no-associated-email *ngSwitchCase="'noAssociatedEmail'"></no-associated-email>
            <no-associated-contact *ngSwitchCase="'noAssociatedContact'"></no-associated-contact>
            <payment-agreement-term *ngSwitchCase="'paymentAgreementTerm'"></payment-agreement-term>
            <agreement-expired *ngSwitchCase="'agreementExpired'" [onRedirectUrl]="''"></agreement-expired>
            <current-payment-agreement *ngSwitchCase="'currentPaymentAgreement'"></current-payment-agreement>
            <payment-agreement-error *ngSwitchCase="'genericError'"></payment-agreement-error>
            <confirmation-error *ngSwitchCase="'confirmationError'"></confirmation-error>
        </ng-container>
    </div>
</div>
